import React, { useState } from "react";
import { Dropdown, DropdownToggle } from "reactstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";

// import images
import defaultAvatar from "../../assets/images/user-icon.svg";

// Removed getCompanyListToSwitch import
import useAuthUser from "../Hooks/useAuthUser";
import formatPersonName from "../../helpers/formatPersonName";

const MenuDropdown = () => {
  const { t } = useTranslation();
  const { isSuperAdmin, tenantProfile, userProfile } = useAuthUser();
  const { user, userStatus, userSwitchCompany } = useSelector((state) => ({
    user: state.Profile.user,
    userStatus: state.Profile.status,
    userSwitchCompany: state.Profile.userSwitch.company,
  }));

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);

  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  // Helper function to get display name
  const getDisplayName = () => {
    // Try to get user's full name from userProfile (authUser storage)
    // Handle both snake_case (first_name, last_name) and camelCase (firstName, lastName)
    const firstName = userProfile?.first_name || userProfile?.firstName;
    const lastName = userProfile?.last_name || userProfile?.lastName;

    if (firstName && lastName) {
      return formatPersonName(firstName, lastName);
    }

    // Fall back to email username (part before @)
    if (userProfile?.email) {
      return userProfile.email.split("@")[0];
    }

    return t("nav.defaultUserName");
  };

  // Helper function to get subtitle
  const getSubtitle = () => {
    // For super admin, don't show organization name
    if (isSuperAdmin) {
      return "";
    }

    // Fall back to tenant name
    if (tenantProfile?.name) {
      return tenantProfile.name;
    }

    // Show tenant handle as subtitle
    if (tenantProfile?.handle) {
      return tenantProfile.handle;
    }

    return "";
  };

  return (
    <React.Fragment>
      <Dropdown
        disabled={true}
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="btn"
          style={{ cursor: "default" }}
        >
          <span className="d-flex align-items-center">
            <img
              className="header-profile-user icon-sm"
              src={userProfile?.profilePictureUrl || defaultAvatar}
              alt="Header Avatar"
              style={{ objectFit: "cover", borderRadius: "50%" }}
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userStatus === "loading"
                  ? t("common.loading")
                  : getDisplayName()}
              </span>
              <span className="d-none d-xl-block ms-1 fs-13 text-muted user-name-sub-text">
                {userStatus === "loading" ? "..." : getSubtitle()}
              </span>
            </span>
          </span>
        </DropdownToggle>
      </Dropdown>
    </React.Fragment>
  );
};

export default MenuDropdown;
